// M5.14: Chronicles API client + types. Tiny module —
// just a single GET against the anonymous public-board
// endpoint. The same data shape is returned for both
// /chronicles (the page) and any future embed.

import { api } from '../../lib/api';

export interface Chapter {
  id: string;
  /** ISO 8601 UTC start of the hour the chapter covers. */
  hour_utc: string;
  chapter_title: string;
  paragraph: string;
  theme_version: string;
  /** ISO 8601 UTC created-at. */
  created_at: string;
  /**
   * v0.7.22: list of actor names referenced in this
   * chapter, derived server-side from the chapter's
   * featured_event_ids (JOIN through ingestor_actor +
   * user). The page uses this list to wrap each name
   * in a styled <span> on render, so the operator (or
   * wall-TV reader) can see at a glance which people
   * are mentioned. Empty array if the chapter has no
   * events or all actors have since been deleted.
   */
  actor_names: string[];
}

export interface ChroniclesResponse {
  team_id: string | null;
  chapters: Chapter[];
  // M5.14 page age cap: the resolved window the api
  // applied to this query. The page can use this to
  // display "Last chapter: Nh ago" + "Window: 24h" so
  // the operator knows what they're seeing.
  window_hours: number;
}

export async function fetchChronicles(
  teamId?: string,
  limit = 3,
): Promise<ChroniclesResponse> {
  const params = new URLSearchParams();
  if (teamId) params.set('team_id', teamId);
  params.set('limit', String(limit));
  const qs = params.toString();
  return api<ChroniclesResponse>(`/api/public-board/chronicles${qs ? `?${qs}` : ''}`);
}
